export default __webpack_public_path__ + "static/media/th.45afd8ca.svg";